import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgxScrollTopModule } from 'ngx-scrolltop'; //Se usa en app.component.html
import { NgxUiLoaderModule } from "ngx-ui-loader"; //Se usa en app.component.html
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './components/common/footer/footer.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';

import { AuthModule } from '../app/auth/auth.module';
import { AuthService } from './auth/auth.service';
import { LoadingInterceptor } from './components/common/loading/loading/loading.interceptor';
import { LoadingModule } from './components/common/loading/loading/loading.module';
import { SharedModule } from './shared/shared.module';
import { VerificatioCodeWhatsappComponent } from './components/common/verification_code_whatsapp/verification_code_whatsapp.component';
import { SimpleNavbarComponent } from './components/common/simple_navbar/simple_navbar.component';
import { InstallersFormComponent } from './modules/quotation-jalisco/pages/installers_form/installers_form.component';

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        NavbarComponent,
        VerificatioCodeWhatsappComponent,
        InstallersFormComponent,
        SimpleNavbarComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        NgxScrollTopModule,
        NgxUiLoaderModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        AuthModule,
        SharedModule,
        LoadingModule
    ],
    providers: [
        AuthService,
        // { provide: NgChartsConfiguration, useValue: { generateColors: false }},
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true } // Ver si se puede quitar de aquí porque está en AuthModule
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
